// Owner-framing disclosure for available-soon surfaces (Legal-approved wording).
export const AVAILABLE_SOON_DISCLOSURE =
  '“Available Soon” homes shown are owned by Opendoor and not subject to listing agreements with Opendoor Brokerage, Opendoor Affiliates, or other brokerages.';
